var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GChart',{staticClass:"headline mx-4",staticStyle:{"width":"110%","height":"400px"},attrs:{"type":"PieChart","data":_vm.chartArray,"options":_vm.chartOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }